import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import { LoginCard } from '../components/LoginCard'
import { loginPageClass } from '../lib/ui'

/** Отдельный маршрут `/login` (то же поведение, что форма на `/`). */
export function LoginPage() {
  const { user, loading } = useAuth()
  const location = useLocation()
  const rawFrom = (location.state as { from?: string } | null)?.from || '/'
  const from = rawFrom.startsWith('/') ? rawFrom : '/'

  if (!loading && user) {
    return <Navigate to={from} replace />
  }

  return (
    <div className={loginPageClass}>
      <LoginCard afterLoginTo={from} showHomeLink />
    </div>
  )
}
